import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPointsContact } from '../common/apiUrls/api-end-points-contact';
import { ApiEndPointsDocument } from '../common/apiUrls/api-end-points-document';
//import { ApiEndPointsContact } from 'src/app/applicationModules/core/common/apiUrls/api-end-points-contact';


@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private baseUrl:any;
  private baseUrll:any;
  private baseUrlClm:any;
  private baseUrlTran:any;
  private baseURlOrg:any;
  private baseUrlFilter:any;
  private baseUrlRole:any;
  private baseUrlUser: any;
  constructor(private _http: HttpClient, 
  private apiAddressContact: ApiEndPointsContact,private apiAddress: ApiEndPointsDocument, public env: EnvService,
  private constant: Constants) {
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrl = this.constant.ManageContactsportNumber;
else
     this.baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrll = this.constant.ManageCoreportNumber;
else
     this.baseUrll = this.env.apiUrl+this.constant.ManageCoreportNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
else
     this.baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlTran = this.constant.ManageTranscationportNumber;
else
     this.baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
else
     this.baseURlOrg = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlFilter = this.constant.AuthPortNumber;
else
     this.baseUrlFilter = this.env.apiUrl+this.constant.AuthPortNumber;
    
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlRole = this.constant.RolePortNumber;
else
     this.baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber;
     if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlUser = this.constant.ManageUserPortNumber;
    else
      this.baseUrlUser = this.env.apiUrl + this.constant.ManageUserPortNumber;
  }
    // private baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
    // // private baseUrll = this.env.apiUrl+this.constant.ManageCoreportNumber;
    // private baseUrll = this.constant.ManageCoreportNumber;
    // // private baseUrlClm = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
    // private baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
    // private baseUrlTran = this.constant.ManageTranscationportNumber;
    // //private baseURlOrg=this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
    // private baseURlOrg=this.constant.ManageOrganizationPortNumber;
    // // private baseUrlFilter = this.env.apiUrl+this.constant.AuthPortNumber;
    // private baseUrlFilter = this.constant.AuthPortNumber;
    // // private baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber; 
    // private baseUrlRole = this.constant.RolePortNumber; 
    
    getContactList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.getContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    } 
    
    GetUserPreferences(userid): Observable<any> {
      const queryParam = '?UserID='+userid;
      const apiURL = this.baseUrlFilter + this.apiAddressContact.GetUserPreferences + '' + queryParam;
      return this._http.get(apiURL).pipe();     
    }
    
    AddPrefrences(reqModel): Observable<any> {
      const apiURL = this.baseUrlFilter + this.apiAddressContact.AddPrefrences;
      return this._http.post(apiURL, reqModel).pipe();
    }

    // getCoreFeildList(reqModel): Observable<any> {
    //   const apiURL = this.baseUrl + this.apiAddress.getCoreFeildList;
    //   return this._http.post(apiURL, reqModel).pipe();
    // }

    getContactFavoriteList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.getFavoriteContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    } 

    getFilteredContactsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.GetFilteredContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    MakeFilterFavorite(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.MakeFilterFavorite;
      return this._http.post(apiURL, reqModel).pipe();
    }
   
    getContactRecentFilter(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.getContactRecentFilter;
      return this._http.post(apiURL, reqModel).pipe();
    } 

    getContactUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.getContactUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getContactFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrll + this.apiAddressContact.getContactFeildList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    geDefaultFilterFieldsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.getDefaultFilterFieldsList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    CreateFilter(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.CreateFilter;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getImageUlpoadURL(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.getImageUploadURL;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.getContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }
 
    
    getAllContactTypeFilterList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.GetAllFillters;
      return this._http.post(apiURL, reqModel).pipe();
    }

    updateContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.updateContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    ReorderContactFieldColumnList(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.ReorderContactFieldColumn;
      return this._http.post(apiURL, reqModel).pipe();
    }

    saveContactFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.saveContactFieldList;
      return this._http.post(apiURL, reqModel).pipe();
    }
    saveContactUserDetails(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.saveContactUserDetails;
      return this._http.post(apiURL, reqModel).pipe();
    }

    DeleteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.DeleteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FavoriteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.FavoriteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FavoriteDeleteContactTransaction(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran + this.apiAddressContact.FavoriteDeleteContactTransaction;
      return this._http.post(apiURL, reqModel).pipe();
    }

    searchTransCities(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran  + this.apiAddressContact.searchTransCities;
      return this._http.post(apiURL, reqModel).pipe();
    }
    searchTransZip(reqModel): Observable<any> {
      const apiURL = this.baseUrlTran  + this.apiAddressContact.searchTransZip;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getStateList(countryId): Observable<any> {
      const apiCallingURl = this.baseURlOrg + this.apiAddressContact.getStateList;
      return this._http.post(apiCallingURl, countryId).pipe();
    }

    RemoveSelectedFilter(reqModel): Observable<any> {
      const apiURL = this.baseUrlClm + this.apiAddressContact.RemoveSelectedFilter;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;

    getContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrl + this.apiAddress.getContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanyContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanyContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanys(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanys;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactCompanys(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactCompanys;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactCores(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactCores;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanyCores(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanyCores;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedContactContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedContactContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedCompanyContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedCompanyContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteContactSelectedCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteContactSelectedCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }


    deleteSelectedRoleCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedRoleCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedRoleContactCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedRoleContactCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }


    GetContactListCoreImplementation(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetContactListCoreImplementation;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetCompanyListCoreImplementation(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetCompanyListCoreImplementation;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getTransactinalRoles(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getTransactinalRoles;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCoreContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    addUpdateContactContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCompanyContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCompanyContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    

    addUpdateContactCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCoreCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    

    addUpdateCoreContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateContactContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCompanyContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCompanyContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCoreCompanyRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreCompanyRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateContactCompanyRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactCompanyRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getSharedAccessRoles(reqModel): Observable<any> {
      const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addPortalAccessToContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addPortalAccessToContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetUserList(reqModel): Observable<any> {
      const apiURL = this.baseUrlUser + this.apiAddress.GetUserList;
      return this._http.post(apiURL, reqModel).pipe();
    }
}
